module.exports = __webpack_public_path__ + "static/media/standard.a31edcc6.jpg";